<div class="flex flex-col items-center justify-center w-[275px] gap-3">
    <div class="flex flex-col w-[275px] min-h-[385px] card-shadow mtg-card-rounded card-background">
        @if (focusedCard) {
            <img class="w-[275px] h-[385px] mtg-card-rounded" [attr.src]="getImageUrl()"/>
            <div class="flex flex-row gap-4 text-sm p-1 text-slate-50 pl-4 pr-4 w-full">
                <div class="w-1/4">
                    {{ getCollectedCount() }}
                </div>
                <div class="w-1/2 flex flex-row gap-4 justify-center">
                    @if (hasPrice()) {
                        <div class="">{{ getPrice() }}</div>
                    }
                    @if (hasSpecialPrice()) {
                        <div class="text-foil">{{ getSpecialPrice() }}</div>
                    }
                </div>
                <div class="w-1/4 text-right text-foil">
                    {{ getSpecialCollectedCount() }}
                </div>
            </div>
        }
    </div>
    <button (click)="flipFace()" class="flex flex-row items-center justify-center gap-1 bg-slate-100 w-[140px] shadow border border-ponder-light text-ponder-light p-1 rounded" [ngClass]="{ 'invisible' : !canCardFlip() }">
        <svg class="w-5 h-5 fill-none stroke-ponder-light" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="flipIconSvg" />
        </svg>
        Flip
    </button>
</div>